import React, { useState, useContext } from 'react'
import { ContentHeader } from '../../layout/Content'
import ReceiptsListHeaderStyle from './css/ReceiptsListHeaderStyle'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Searchbar from '../../layout/searchbar/Searchbar'
import ToolbarButton from '../../layout/ToolbarButton'
import ReceiptsListSettingsForm from './forms/ReceiptsListSettingsForm'
import ReactDOM from 'react-dom';
import ModalWindow from '../../layout/modalwindow/ModalWindow';
import { receiptsListControllerContext } from './ReceiptsListController'

function ReceiptsListHeaderToolbar(props) {
  const receiptsListController = useContext(receiptsListControllerContext)
  const { refreshList } = receiptsListController

  const onClickSettings = (e) => {
    ReactDOM.render(
      <ModalWindow id='mw-parent' width='30' height='50' header='Settings' footer={null}>
        <ReceiptsListSettingsForm receiptsListController={receiptsListController} />
      </ModalWindow>,
      document.getElementById('modal-form-container')
    )
  }

  const onClickRefresh = (e) => { refreshList() }

  return (
    <ToolbarButton>
      <button
        type="button"
        className={ props.search ? 'pospro-action-btn toolbar-btn disabled-button' : 'pospro-action-btn toolbar-btn' }
        id="refresh-list-btn"
        disabled={props.search}
        name="tb"
        onClick={onClickRefresh}
        title='Refresh list'>
        <FontAwesomeIcon icon='sync-alt'/>
        <span className='tooltip-text'>Refresh list</span>
      </button>
      <button
        id='settings-btn'
        name='tb'
        className='pospro-action-btn toolbar-btn'
        onClick={onClickSettings}>
        <FontAwesomeIcon icon='cog'/>
        <span className='tooltip-text'>Settings</span>
      </button>
    </ToolbarButton>
  )
}

function ReceiptsListHeader() {
  const receiptsListController = useContext(receiptsListControllerContext)
  const { filterReceiptsList } = receiptsListController
  const [searchReceiptsList, setSearchReceiptsList] = useState('')

  const searchbarProps = {
    search: searchReceiptsList,
    setSearch: setSearchReceiptsList,
    filter: filterReceiptsList
  }

  return (
    <ContentHeader title='Receipts List'>
      <div id='receipts-list-toolbar'>
        <Searchbar { ...searchbarProps }/>
        <ReceiptsListHeaderToolbar { ...searchbarProps }/>
      </div>
      <ReceiptsListHeaderStyle />
    </ContentHeader>
  )
}

export default React.memo(ReceiptsListHeader)